import { inject } from '@angular/core';
import { createInjectable } from 'ngxtension/create-injectable';
import { signalSlice } from 'ngxtension/signal-slice';
import { catchError, distinctUntilChanged, EMPTY, filter, map, switchMap } from 'rxjs';
import type { UserContextGetResponseType } from '@tig-dpqa-cloud/contract-backend-backoffice';
import { HttpClient } from '@angular/common/http';
import { StorageService } from '../storage/storage.service';

export const UserContextService = createInjectable(
  () => {
    const http = inject(HttpClient);
    const storageService = inject(StorageService);

    const initialState: {
      userPermissions: UserContextGetResponseType['user']['permissions'] | undefined;
      userProfile: Omit<UserContextGetResponseType['user'], 'permissions'> | undefined;
    } = {
      userProfile: undefined,
      userPermissions: undefined,
    };

    const userContext$ = storageService.watch('token').pipe(
      filter(Boolean),
      distinctUntilChanged(),
      switchMap(() =>
        http.get<UserContextGetResponseType>('/api/user/context').pipe(
          map((res) => ({
            userPermissions: res.user.permissions,
            userProfile: {
              firstName: res.user.firstName,
              lastName: res.user.lastName,
              email: res.user.email,
            },
          })),
          catchError(() => EMPTY),
        ),
      ),
    );

    const state = signalSlice({
      initialState,
      sources: [userContext$],
    });

    return {
      userProfile: state.userProfile,
      userPermissions: state.userPermissions,
    };
  },
  { providedIn: 'root' },
);
